// extracted by mini-css-extract-plugin
module.exports = {"content":"MyInfoError_content__2vdd4","wrapper":"MyInfoError_wrapper__2qhX7","text":"MyInfoError_text__CVbs0","button":"MyInfoError_button__3mKrw","list":"MyInfoError_list__2zdZO"};